import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Logo from '../images/Collagelogo.png';
import '../admin/style/login.css';
import Header from '../repeat/Header';

const LoginPage = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const storedUsername = sessionStorage.getItem('username');
    if (storedUsername) {
      navigate('/AdminDashboard');
    } else {
      setIsLoading(false);
    }
  }, [navigate]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    const url = 'https://gptkpm.in/backend/admin/login.php';

    let fData = new FormData();
    fData.append('username', username);
    fData.append('password', password);

    try {
      const response = await axios.post(url, fData);

      if (response.data.status === "success") {
        sessionStorage.setItem('username', username);
        navigate("/AdminDashboard");
      } else {
        alert(response.data.message);
      }
    } catch (error) {
      alert("Error: " + error.message);
    }
  };

  return (
    <div className="container1">
      <Header />
      <div className="logincontainer">
        <div className="box1">
          <img src={Logo} alt="Login" />
        </div>
        <div className="box2">
          <form onSubmit={handleSubmit}>
            <div className="text">
              <h1>Welcome</h1>
              <p>Please Login To Admin Dashboard</p>
            </div>
            <div className="input">
              <input
                type="text"
                id="username"
                placeholder="Username"
                value={username}
                name="username"
                onChange={(e) => setUsername(e.target.value)}
                required
              />
              <input
                type="password"
                id="password"
                placeholder="Password"
                name="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <div className="password" style={{ flexDirection: "row" }}>
                <div className="showpassword">
                  <input
                    type="checkbox"
                    onChange={(e) => {
                      const input = document.getElementById("password");
                      input.type = e.target.checked ? "text" : "password";
                    }}
                  />
                  <p style={{ whiteSpace: "nowrap" }}>Show Password</p>
                </div>
                <a
                  href="#"
                  id="forgot"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/Forgot");
                  }}
                >
                  Forgot Password?
                </a>
              </div>
              <input type="submit" />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
